<template>

  <div>

    <candidate-feed
      :activityType="['note', 'evaluation', 'task', 'move', 'qualification', 'meetinsight', 'email', 'event', 'questionnaire', 'intervideo', 'intervoice']">
      </candidate-feed>
   
  </div>

</template>

<script>
import CandidateFeed from '../Feed/CandidateFeed'

export default {
  name: 'CandidateTimeline',
  components: {
    CandidateFeed
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Timeline/CandidateTimeline.vue